<script setup lang="ts">
import { ICON } from "@/lib/icons"
</script>

<template>
  <UApp>
    <div class="flex min-h-svh flex-col items-center justify-center p-4">
      <div class="w-full max-w-sm">
        <div class="mb-6 flex justify-center">
          <UIcon :name="ICON.logo" class="text-primary size-10" />
        </div>

        <slot />

        <div class="mt-6 flex justify-center" data-teleport-dev-only />
      </div>
    </div>
  </UApp>
</template>
